import React from "react";
import WorksProcessSection from "../pages/WorksProcessSection";
import Testimonials from "../pages/Testimonialsabout";

const AboutSection = () => {
  return (

<>



<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1>About Us</h1>
        </div>
      </div>
    </section>

    <section className="about-section pt_120 pb_120">
      <div className="shape">
        <img src="/images/shape/shape-7.png" alt="Shape decoration" />
      </div>
      <div className="container">
        <div className="row">
          {/* Left Image */}
          <div className="col-xl-6 col-lg-6 col-md-12">
            <div className="about-left-image">
              <img src="/images/aboutimg.jpg" alt="About us" />
            </div>
          </div>

          {/* Right Content */}
          <div className="col-xl-6 col-lg-6 col-md-12">
            <div className="section-title pt_50 mb_30">
              <span className="sub-title">Sai Trupti Cabs</span>
              <h2 className="title">
                Reliable, Comfortable & Affordable
<br />Cab Services in Pune
              </h2>
            </div>

            <div className="about-info-block mb_30">
              <div className="about-info-icon">
                <i className="icon-35"></i>
              </div>
              <div className="about-info-content">
                <h5 className="about-info-title">Outstation & Airport Transfers</h5>
                <p className="about-info-text">
                  From Pune to Mumbai Airport or weekend trips to Mahabaleshwar, we offer hassle-free intercity rides.
                </p>
              </div>
            </div>

            <div className="about-info-block">
              <div className="about-info-icon">
                <i className="icon-34"></i>
              </div>
              <div className="about-info-content">
                <h5 className="about-info-title">24/7 Booking Support</h5>
                <p className="about-info-text">
                  Reach us anytime for instant cab bookings, fare quotes, or travel planning assistance across Maharashtra
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <WorksProcessSection/>
    <Testimonials/>
</>
  );
};

export default AboutSection;
